import { render, staticRenderFns } from "./bottomText.vue?vue&type=template&id=33a4f1c4"
import script from "./bottomText.vue?vue&type=script&lang=js"
export * from "./bottomText.vue?vue&type=script&lang=js"
import style0 from "./bottomText.vue?vue&type=style&index=0&id=33a4f1c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports